import './scss/index.scss';
import ComponentsFactory from '../../foundation/components-factory';
import IMGAMatchupsGameComponent from './js/imga-matchups-game.component';

ComponentsFactory.getInstance().define('imga-matchups-game', IMGAMatchupsGameComponent);
